import { ABTestLimit, DecodedTestInformation } from "./variationId";

export function getExclusiveTestIfEligible(
  testsCurrentlySavedInCookie: DecodedTestInformation[],
  allActiveFeatBitTestsInformation: DecodedTestInformation[],
  currentLimit: number,
): DecodedTestInformation | undefined {
  const activeExclusiveTests = allActiveFeatBitTestsInformation.filter(
    (featBitTest) => featBitTest.exclusive,
  );
  if (!activeExclusiveTests.length) return;

  const existingFullTestIds = testsCurrentlySavedInCookie.map(
    (cookieTest) => cookieTest.fullTestId,
  );

  for (const activeTest of activeExclusiveTests) {
    if (existingFullTestIds.includes(activeTest.fullTestId)) {
      return activeTest;
    }
  }
  if (currentLimit < ABTestLimit) return;

  const firstRuleMatchedExclusiveTest = activeExclusiveTests.find(
    (activeExclusiveTest) => activeExclusiveTest.kind === "RuleMatch",
  );
  if (firstRuleMatchedExclusiveTest) {
    return firstRuleMatchedExclusiveTest;
  }
}
